import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="subscribe-modal.price-per-month.text" defaultMessage="/ month" />
);
